import { Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function ProcessHeadingRow(props) {
  const width = props.width || "66%";
  return (
    <Typography
      color="primary"
      variant="h6"
      sx={{ width: width, flexShrink: 0 }}
      className="fixPrint">
      {props.txt}
    </Typography>
  );
}

ProcessHeadingRow.propTypes = {
  txt: PropTypes.string,
  width: PropTypes.string,
};
